<script>
export default {
  name: 'Buttons',

  props: {

    wrap: {
      default: false
    },

    vertical: {
      default: false
    }

  }

}
</script>

<template>
  <div
    :class="{
      'c-buttons-wrap': wrap,
      'c-buttons-center': !wrap,
      'c-buttons-vertical': vertical
    }"
    class="c-buttons"
  >
    <slot />
  </div>
</template>

<style lang="scss">

.c-buttons {
  @include flex;
}

.c-buttons-center {
  @include flex-center;

  .c-styled-button {
    + .c-styled-button {
      @include push-pad-tight-left;
    }
  }

}

.c-buttons-wrap {
  @include flex-wrap;
}

.c-buttons-vertical {
  @include flex-vertical;
}

</style>
